import { render, staticRenderFns } from "./CIncomeAddItemModal.vue?vue&type=template&id=36d92b3c&scoped=true&"
import script from "./CIncomeAddItemModal.vue?vue&type=script&lang=ts&"
export * from "./CIncomeAddItemModal.vue?vue&type=script&lang=ts&"
import style0 from "./CIncomeAddItemModal.vue?vue&type=style&index=0&id=36d92b3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d92b3c",
  null
  
)

export default component.exports